import * as t from "io-ts";

export const ViolationCodec = t.intersection([
  t.type({
    key: t.string,
    severity: t.string,
    message: t.string,
  }),
  t.partial({
    path: t.string,
  }),
]);

export type Violation = t.TypeOf<typeof ViolationCodec>;
